module.exports = __webpack_public_path__ + "img/a2_2.b9b7c322.jpg";